import fr from './fr.json';
import en from './en.json';
import sl from './sl.json';
import it from './it.json';
import es from './es.json';
import de from './de.json';
import uk from './uk.json';

export const dictionaryList = { en, fr, sl, it, es, de, uk };

export const languageOptions = {
  fr: 'Français',
  en: 'English',
  sl: 'Slovenščina',
  it: 'Italiano',
  es: 'Español',
  de: 'Deutsch',
  uk: 'Українська'
};
